import FAQ from './FAQ';

function ZonnepanelenFAQ() {
  const faqs = [
    {
      question: 'Hoeveel zonnepanelen heb ik nodig?',
      answer: 'Het aantal benodigde zonnepanelen hangt af van uw stroomverbruik en beschikbare dakoppervlak. Voor een gemiddeld huishouden (3.500 kWh/jaar) adviseren we 10-12 panelen. We maken een berekening op basis van uw specifieke situatie.'
    },
    {
      question: 'Wat is de terugverdientijd van zonnepanelen?',
      answer: 'De gemiddelde terugverdientijd is 5-7 jaar, afhankelijk van uw stroomverbruik, systeemgrootte en energieprijzen. Met de huidige energieprijzen kan dit zelfs korter zijn. We maken een gedetailleerde berekening voor uw situatie.'
    },
    {
      question: 'Moet mijn meterkast worden aangepast?',
      answer: 'Dit hangt af van uw huidige installatie. Voor zonnepanelen is een aparte groep nodig en soms een verzwaarde aansluiting. Bij de inspectie controleren we of aanpassingen nodig zijn en nemen dit mee in de offerte.'
    },
    {
      question: 'Welke garanties krijg ik?',
      answer: 'We geven 10 jaar garantie op de installatie, 12-25 jaar op de panelen (vermogensgarantie) en 10-12 jaar op de omvormer. Daarnaast krijgt u een keuringsrapport en garantiecertificaat.'
    },
    {
      question: 'Kan ik de opgewekte stroom opslaan?',
      answer: 'Ja, dit kan met een thuisbatterij. Dit wordt steeds interessanter door stijgende energieprijzen en dalende terugleververgoedingen. We adviseren u graag over de mogelijkheden en het rendement van energieopslag.'
    }
  ];

  return <FAQ title="Veelgestelde vragen over zonnepanelen" faqs={faqs} />;
}

export default ZonnepanelenFAQ;